import * as React from "react"
import { Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import "./activityIndicator.styles.scss"

export const ActivityIndicator = props => {
  const { styles, global, ...rest } = props
  const defaultStyles = { fontSize: 24 }
  const icon = <LoadingOutlined style={styles || defaultStyles} spin />
  if (global) {
    return (
      <section className="global-activity-indicator">
        <Spin indicator={icon} {...rest} />
      </section>
    )
  }
  return <Spin indicator={icon} {...rest} />
}
